import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FiDownload, FiLock } from 'react-icons/fi';
import { formatMoney } from '../utils/money';

export default function ContadorGuestView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(`/api/contador/guest/${encodeURIComponent(token)}`);
        const json = await res.json();
        if (!res.ok) throw new Error(json.message || 'Link no válido');
        if (!cancelled) setData(json);
      } catch (err) {
        if (!cancelled) setError(err.message || 'No se pudo cargar la vista');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  const packUrl = `/api/contador/guest/${encodeURIComponent(token)}/pack`;

  return (
    <div className="min-h-screen bg-[#f5f5f7] text-gray-900 px-4 py-8">
      <div className="max-w-lg mx-auto space-y-4">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-[#004AAD]">
          <FiLock className="w-4 h-4" />
          Vista contador · solo lectura
        </div>

        {loading && (
          <p className="text-sm text-gray-600">Cargando resumen…</p>
        )}

        {error && (
          <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error}
          </div>
        )}

        {data && (
          <>
            <header className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
              <h1 className="text-xl font-semibold">{data.company}</h1>
              <p className="text-sm text-gray-600 mt-1">
                Compartido por {data.ownerName || 'el cliente'}
              </p>
              {data.expiresAt && (
                <p className="text-xs text-gray-500 mt-2">
                  Link vigente hasta {new Date(data.expiresAt).toLocaleDateString('es-AR')}
                </p>
              )}
            </header>

            <section className="rounded-2xl border border-gray-200 bg-white p-5 space-y-3">
              <h2 className="text-sm font-semibold">Estado operativo</h2>
              <dl className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <dt className="text-gray-500 text-xs">Impagas</dt>
                  <dd className="font-semibold tabular-nums">{data.stats?.impagas ?? 0}</dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">Pendiente</dt>
                  <dd className="font-semibold tabular-nums">
                    {formatMoney(data.stats?.pendienteArs ?? 0, 'ARS')}
                  </dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">Ventas del mes</dt>
                  <dd className="font-semibold tabular-nums">{data.stats?.ventasMes ?? 0}</dd>
                </div>
                <div>
                  <dt className="text-gray-500 text-xs">Egresos del mes</dt>
                  <dd className="font-semibold tabular-nums">{data.stats?.egresosMes ?? 0}</dd>
                </div>
              </dl>
            </section>

            <a
              href={packUrl}
              className="flex items-center justify-center gap-2 w-full rounded-xl bg-[#1F80FF] px-4 py-3 text-sm font-semibold text-white hover:bg-[#1866CC]"
            >
              <FiDownload className="w-4 h-4" />
              Descargar pack ZIP del mes
            </a>

            <p className="text-[11px] text-gray-500 leading-relaxed">
              Registro interno de Contsuite. No es una presentación ante ARCA ni reemplaza asesoramiento profesional.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
